export default __webpack_public_path__ + "static/assets/e6f72b57b0d9ac6966cf74eece091052.png";